import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  CardContent,
  Typography,
  Divider,
  TableSortLabel,
  TextField,
  useTheme,
  Grid,
  MenuItem,
  Autocomplete,
  Button,
} from "@mui/material";
import Icons from "../../Utils/Icons";
import { GET, POST } from "../Generic/CrudRequest";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import ModalGeneric from "../Generic/ModalGeneric";
import { searchPermissions } from "../Users/PermissionsUser/PermissionsActions";
import dayjs from "dayjs";
import moment from "moment";
import utc from "dayjs/plugin/utc";
import useExcelExport from "../../Utils/useExcelExport";
import { SaveAlt } from "@mui/icons-material";



export default function Units(props) {
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("");
  const [column, setColumn] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchVin, setSearchVin] = useState("");
  const [locations, setLocations] = useState([]);
  const [idUbicacion, setIdUbicacion] = useState(0);
  const [fecha, setFecha] = useState(dayjs(new Date()));
  const [fechaFin, setFechaFin] = useState(dayjs(new Date()));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [bodyModal, setBodyModal] = useState(null);
  const [estatus, setEstatus] = React.useState(true);
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState(0);
  const [register, setRegister] = useState(false);
  const [edit, setEdit] = useState(false);
  const [importUnits, setImportUnits] = useState(false);
  dayjs.extend(utc);
  const theme = useTheme();
  const { config } = props;
  const exportToExcel = useExcelExport();
  const handleExport = () => {
    exportToExcel(rows, columns, "UNIDADES.xlsx");
  };

  const columns = [
    { id: "vin", label: "vin", minWidth: "100px" },
    { id: "chasis", label: t("chasis"), minWidth: "100px" },
    { id: "estatus", label: t("status"), minWidth: "100px" },
    { id: "marca", label: t("brand"), minWidth: "100px" },
    { id: "origen", label: t("origin"), minWidth: "100px" },
    { id: "ubicacion", label: t("currentLocation"), minWidth: "100px" },
    { id: "cliente", label: t("client"), minWidth: "100px" },
    { id: "ubicacionDestino", label: t("finalDestination"), minWidth: "100px" },
    { id: "fechaRegistro", label: t("registrationDate"), minWidth: "100px" },
  ];
  useEffect(() => {
    fetchUnits();
    fetchClients();
  }, [page, rowsPerPage, column, order]);

  const fetchUnits = async () => {
    const vinsSeparated = searchVin.split(/[,\s]+/);
    const filteredVins = vinsSeparated.filter((vin) => vin.trim() !== "");

    const queryParams = new URLSearchParams({
      start: page * rowsPerPage,
      length: rowsPerPage,
      idUbicacion: idUbicacion,
      idCliente: client,
      estatus: estatus,
      fechaInicio: fecha,
      fechaFin: fechaFin,
      column: column,
      dir: order,
    });

    const dataUnits = await POST(
      `${config.url}/api/Unit/paginado?${queryParams.toString()}`,
      filteredVins
    );

    setRows(dataUnits.resultado);
    setTotalRecords(dataUnits.totalRegistros);

    const permissionsArray = JSON.parse(localStorage.getItem("permissions"));

    const permissionRegister = searchPermissions(
      "Unidades",
      "Registrar",
      permissionsArray
    );

    const permissionEdit = searchPermissions(
      "Unidades",
      "Editar",
      permissionsArray
    );

    const permissionImportUnits = searchPermissions(
      "Unidades",
      "ImportarUnidades",
      permissionsArray
    );

    setRegister(permissionRegister);
    setEdit(permissionEdit);
    setImportUnits(permissionImportUnits);
  };

  const fetchLocations = async (location, currentPage, perPage) => {
    const dataLocations = await GET(`${config.url}/api/Location/select`, {
      busqueda: location,
      page: currentPage,
      perPage: perPage,
    });

    setLocations(dataLocations.result);
  };

  const fetchClients = async () => {
    const clientsData = await GET(`${config.url}/api/Client`);
    setClients(clientsData);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (property, columnNumber) => {
    const isAsc = orderBy === property && order === "asc";
    setColumn(columnNumber);
    setOrderBy(property);
    setOrder(isAsc ? "desc" : "asc");
  };

  const handleSearch = () => {
    fetchUnits();
  };

  const handleClear = () => {
    setIdUbicacion(0);
    setLocations([]);
    setSearchVin("");
    setFecha(dayjs(new Date()));
    setFechaFin(dayjs(new Date()));
    setClient(0);
    setEstatus(true);
  };

  const handleInputChange = (event, value) => {
    if (value.trim().length >= 3) {
      fetchLocations(value, 1, 10);
    } else {
      setLocations([]);
    }
  };

  const handleModalVins = () => {
    setIsModalOpen(true);
    let modalTitle = t("units.searchVins");
    let modalDescription = t("units.enterVin");
    setModalTitle(modalTitle);
    setModalDescription(modalDescription);
    setBodyModal(
      <>
        <Divider sx={{ maxWidth: "100%", margin: "auto", marginTop: 2 }} />
        <Grid container spacing={2} marginTop={1}>
          <Grid item xs={12}>
            <TextField type="text" fullWidth id="modalTextField" />
          </Grid>
        </Grid>
      </>
    );
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAcceptModal = () => {
    const textFieldValue = document.getElementById("modalTextField").value;
    const vinsString = textFieldValue.replace(/\s+/g, " ").trim();
    setSearchVin(vinsString);

    handleCloseModal();
  };

  const handleChangeVin = (vin) => {
    setSearchVin(vin);
  };

  const handleChangeEstatus = (event) => {
    setEstatus(event.target.value);
  };

  const handleChangeClient = (event) => {
    // console.log(event.target.value);
    setClient(event.target.value);
  };

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
      }}
    >
      {isModalOpen && (
        <ModalGeneric
          open={isModalOpen}
          title={modalTitle}
          description={modalDescription}
          onClose={handleCloseModal}
          onAccept={handleAcceptModal}
          bodyComponent={bodyModal}
        />
      )}
      <CardContent>
        <CardContent
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Typography variant="h3" sx={{ flex: "1", fontWeight: "bold" }}>
            {t("units.title")}
          </Typography>
          {importUnits && (
            <Link
              to="/Unidades/ImportarUnidades"
              style={{ textDecoration: "none" }}
            >
              <Button variant="contained">{t("units.importUnits.importUnitsButton")}</Button>
            </Link>
          )}
          {register && (
            <Icons
              iconName="Add"
              fontSize="large"
              to="/Unidades/Agregar"
              style={{
                marginLeft: "15px",
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
              }}
              tooltip={t("buttons.add")}
            />
          )}
        </CardContent>
        <Divider sx={{ maxWidth: "calc(100% - 32px)", margin: "auto" }} />
        <CardContent
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            alignItems: "auto",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TextField
                label={t("units.vin")}
                type="text"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="standard"
                value={searchVin}
                onChange={(e) => handleChangeVin(e.target.value)}
                sx={{
                  width: 400,
                  maxWidth: "100%",
                  color: theme.palette.primary.main,
                }}
                InputProps={{
                  endAdornment: (
                    <Icons
                      iconName="Add"
                      fontSize="small"
                      onClick={() => handleModalVins()}
                      style={{
                        color: theme.palette.primary.main,
                      }}
                    />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("filters.status")}
                InputLabelProps={{
                  shrink: true,
                }}
                name="estatus"
                variant="standard"
                size="small"
                value={estatus}
                fullWidth
                onChange={handleChangeEstatus}
              >
                <MenuItem value={true}>{t("units.active")}</MenuItem>
                <MenuItem value={false}>{t("units.inactive")}</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                select
                label={t("units.client")}
                name="cliente"
                variant="standard"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                value={client}
                onChange={handleChangeClient}
              >
                <MenuItem key={0} value={0}>
                  {t("select")}
                </MenuItem>
                {clients.map((cliente) => (
                  <MenuItem key={cliente.idCliente} value={cliente.idCliente}>
                    {cliente.nombre}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                options={locations}
                noOptionsText={t("noOptions")}
                getOptionLabel={(location) =>
                  `${location.nombre} ${location.descripcion} ${
                    location.ciudad ?? ""
                  } ${location.ubicacionTipo ?? ""}`
                }
                onChange={(event, value) => {
                  if (value) {
                    setIdUbicacion(value.idUbicacion);
                  }
                }}
                isOptionEqualToValue={(option, value) =>
                  option && value && option.idUbicacion === value.idUbicacion
                }
                onInputChange={handleInputChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("units.location")}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={t("filters.startDate")}
                  value={fecha}
                  fullWidth
                  onChange={(newValue) => {
                    setFecha(dayjs(newValue));
                  }}
                  slots={{
                    textField: (params) => (
                      <TextField variant="standard" fullWidth {...params} />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label={t("filters.endDate")}
                  value={fechaFin}
                  fullWidth
                  onChange={(newValue) => {
                    setFechaFin(dayjs(newValue));
                  }}
                  slots={{
                    textField: (params) => (
                      <TextField variant="standard" fullWidth {...params} />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Icons
              iconName="Search"
              fontSize="large"
              onClick={handleSearch}
              style={{ color: theme.palette.primary.main }}
            />
            <Icons
              iconName="Clear"
              fontSize="large"
              onClick={handleClear}
              style={{ color: theme.palette.primary.main }}
            />
          </Grid>
        </CardContent>
        <Paper
          sx={{
            maxWidth: "calc(100% - 32px)",
            margin: "auto",
            overflow: "hidden",
            boxShadow: "none",
            border: "none",
          }}
        >
          <TableContainer>
            <Button
              variant="contained"
              startIcon={<SaveAlt />}
              onClick={handleExport}
            >
              {t("buttons.exportExcel")}
            </Button>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align="left"
                      style={{ minWidth: column.minWidth, fontWeight: "bold" }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={() =>
                          handleRequestSort(column.id, columns.indexOf(column))
                        }
                      >
                        {t(`units.${column.label}`)}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={columns.length + 1} align="center">
                      {t("units.noUnitsAvailable")}
                    </TableCell>
                  </TableRow>
                )}
                {rows.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      {columns.map((column) => (
                        <TableCell key={column.id} align="left">
                          {column.id === "fechaRegistro" ? (
                            row.fechaRegistro !== null ? (
                              <span>
                                {moment
                                  .utc(row.fechaRegistro)
                                  .local()
                                  .format("MM/DD/YYYY HH:mm A")}
                              </span>
                            ) : (
                              <i>{t("pagination.notAvailable")}</i>
                            )
                          ) : column.id === "estatus" ? (
                            row.estatus === true ? (
                              t("units.active")
                            ) : (
                              t("units.inactive")
                            )
                          ) : column.id === "origen" ? (
                            row.ubicacion !== null ? (
                              row.ubicacion
                            ) : (
                              <i>{t("pagination.notAvailable")}</i>
                            )
                          ) : row[column.id] !== null &&
                            row[column.id] !== "" ? (
                            row[column.id]
                          ) : (
                            <i>{t("pagination.notAvailable")}</i>
                          )}
                        </TableCell>
                      ))}
                      <TableCell align="right">
                        {edit && (
                          <Icons
                            iconName="Edit"
                            fontSize="medium"
                            style={{
                              backgroundColor: theme.palette.primary.main,
                              color: "#fff",
                            }}
                            to={`/Unidades/Editar/${row.idUnidad}`}
                            tooltip={t("buttons.edit")}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100, { value: -1, label: t("pagination.all") }]}
            component="div"
            count={totalRecords}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("pagination.labelRowsPerPage")}
            labelDisplayedRows={({ from, to, count }) =>
              t("pagination.displayedRows", { from, to, count })
            }
          />
        </Paper>
      </CardContent>
    </Card>
  );
}
